import React, { createContext, useContext, useState } from 'react';

export const PageContext = createContext({ badge: null, logo: null, setBadge: () => {}, setLogo: () => {} });

export function PageProvider({ children }) {
  const [badge, setBadge] = useState(null);
  const [logo,  setLogo]  = useState(null);
  return (
    <PageContext.Provider value={{ badge, logo, setBadge, setLogo }}>
      {children}
    </PageContext.Provider>
  );
}

export function usePageContext() {
  return useContext(PageContext);
}
